import { useState } from "react";

function MealSection({ label, emoji, items, foods, onAdd, onRemove, onAddNewFood }) {
  const [showNewFood, setShowNewFood] = useState(false);
  const [newFoodName, setNewFoodName] = useState("");
  const [newFoodHealthy, setNewFoodHealthy] = useState(false);

  const handleSelectFood = (e) => {
    const foodName = e.target.value;
    if (foodName === "__new__") {
      setShowNewFood(true);
      return;
    }
    if (!foodName) return;

    const food = foods.find((f) => f.name === foodName);
    if (food && !items.some((i) => i.name === food.name)) {
      onAdd({ name: food.name, healthy: food.healthy });
    }
    e.target.value = "";
  };

  const handleAddNewFood = () => {
    if (!newFoodName.trim()) return;
    const food = { name: newFoodName.trim(), healthy: newFoodHealthy };
    onAddNewFood(food);
    onAdd(food);
    setNewFoodName("");
    setNewFoodHealthy(false);
    setShowNewFood(false);
  };

  return (
    <div className="meal-section">
      <h4>{emoji} {label}</h4>

      <select onChange={handleSelectFood} defaultValue="">
        <option value="">+ Dodaj hranu...</option>
        {foods.map((food) => (
          <option key={food.name} value={food.name}>
            {food.name} {food.healthy ? "🥗" : ""}
          </option>
        ))}
        <option value="__new__">➕ Nova hrana...</option>
      </select>

      {showNewFood && (
        <div className="new-food-form">
          <input
            type="text"
            value={newFoodName}
            onChange={(e) => setNewFoodName(e.target.value)}
            placeholder="Naziv hrane..."
          />
          <label>
            <input
              type="checkbox"
              checked={newFoodHealthy}
              onChange={(e) => setNewFoodHealthy(e.target.checked)}
            />
            Zdrava
          </label>
          <button className="add" onClick={handleAddNewFood}>Dodaj</button>
          <button onClick={() => setShowNewFood(false)}>Odustani</button>
        </div>
      )}

      {items.length > 0 && (
        <ul className="item-list">
          {items.map((item, index) => (
            <li key={index}>
              <span>{item.name} {item.healthy ? "🥗" : "🍔"}</span>
              <button className="danger" onClick={() => onRemove(index)}>✕</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default function Nutrition({ value, onChange, foods, onAddFood }) {
  const meals = [
    { key: "breakfast", label: "Doručak", emoji: "🌅" },
    { key: "snack1", label: "Užina 1", emoji: "🍎" },
    { key: "lunch", label: "Ručak", emoji: "🍽️" },
    { key: "snack2", label: "Užina 2", emoji: "🥤" },
    { key: "dinner", label: "Večera", emoji: "🌙" }
  ];

  const addToMeal = (mealKey, food) => {
    onChange({
      ...value,
      [mealKey]: [...(value[mealKey] || []), food]
    });
  };

  const removeFromMeal = (mealKey, index) => {
    onChange({
      ...value,
      [mealKey]: value[mealKey].filter((_, i) => i !== index)
    });
  };

  const handleCheckbox = (field) => {
    onChange({
      ...value,
      [field]: !value[field]
    });
  };

  return (
    <div>
      <h3>🍽️ Ishrana</h3>

      {meals.map((meal) => (
        <MealSection
          key={meal.key}
          label={meal.label}
          emoji={meal.emoji}
          items={value[meal.key] || []}
          foods={foods}
          onAdd={(food) => addToMeal(meal.key, food)}
          onRemove={(index) => removeFromMeal(meal.key, index)}
          onAddNewFood={onAddFood}
        />
      ))}

      <hr />

      <div className="checkbox-group">
        <label>
          <input
            type="checkbox"
            checked={value.fruit}
            onChange={() => handleCheckbox("fruit")}
          />
          Jeo/la voće
        </label>

        <label>
          <input
            type="checkbox"
            checked={value.healthy}
            onChange={() => handleCheckbox("healthy")}
          />
          Jeo/la nešto zdravo
        </label>
      </div>
    </div>
  );
}
